import { inject, Injectable } from '@angular/core';
import { HttpMainService } from '../http-main.service';
import { CurrencyResponseModel, ListModel } from '@itb-monorepo/models';
import { Observable } from 'rxjs';

@Injectable()
export class CurrencyService {
    baseUrl = '/finance/';
  private _HttpMainService = inject(HttpMainService);

    getCurrencies(isCrypto: boolean = true): Observable<ListModel<CurrencyResponseModel>> {
        let filter = `network:nnull()`;
        if (!isCrypto) {
            filter = `network:null()`;
        }

        return this._HttpMainService.get(this.baseUrl + "v1/currencies", {
            sort: `asc(priority)`,
            filter: filter
        });
    }

}
